export default __webpack_public_path__ + "assets/svg/StabilityBall.f3a608ad612c88baf8f3ddf7e2e7b78f.svg";